import React from 'react';

export type ArrivalProperty = {
  housingId?: string;
  name?: string;
  address?: string;
  location?: string;
  city?: string;
  country?: string;
  isPoliceRegistered?: boolean;
  isLoading?: boolean;
};

const ArrivalPropertyContext = React.createContext<ArrivalProperty>({});

function useArrivalProperty(): ArrivalProperty {
  return React.useContext(ArrivalPropertyContext);
}

export {ArrivalPropertyContext, useArrivalProperty};
